export const ana_sponsorluk =
{
    title: "Ana Sponsorluk",
    className: "ana",
    features: [
        { id: 1, text: "Ayrıcalıklı alanda stant imkânı" },
        { id: 2, text: "Firma isim ve logosunun fuar web sitesinde, sosyal medya hesaplarında ve Cumhurbaşkanlığı Yetenek Kapısı'nda Ana Sponsor olarak duyurulması" },
        { id: 3, text: "Tüm materyallerde firma logosuna yer verilmesi" },
        { id: 4, text: "Açılış protokolü sunum alanı arkasında logo kullanım hakkı" },
        { id: 5, text: "Firma yetkililerine fuar protokolünde yer verilmesi, protokol düzeyinde ağırlama ve açılışta plaket takdimi" },
        { id: 6, text: "Fuar boyunca konferansların düzenleneceği merkezin ana salonundaki led ekranda tanıtım filmi gösterimi hakkı" },
        { id: 7, text: "Konferans salonu tahsis edilmesi" },
        { id: 8, text: "Yüz yüze görüşme alanı kullanma imkânı" },
        { id: 9, text: "Etkinlikler için atölye alanı tahsis edilmesi" }
    ]
}

export const altin_sponsorluk =
{
    title: "Altın Sponsorluk",
    className: "altin",
    features: [
        { id: 0, text: "Ayrıcalıklı alanda stant imkânı" },
        { id: 1, text: "Firma isim ve logosunun fuar web sitesinde, sosyal medya hesaplarında ve Cumhurbaşkanlığı Yetenek Kapısı'nda Altın Sponsor olarak duyurulması" },
        { id: 2, text: "Açılış protokolü sunum alanı arkasında logo kullanım hakkı" },
        { id: 3, text: "Firma yetkililerine fuar protokolünde yer verilmesi, protokol düzeyinde ağırlama" },
        { id: 4, text: "Konferans salonu tahsis edilmesi" },
        { id: 5, text: "Yüz yüze görüşme alanı kullanma imkânı " },
        { id: 6, text: "Etkinlikler için atölye alanı tahsis edilmesi" }
    ]
}

export const gumus_sponsorluk =
{
    title: "Gümüş Sponsorluk",
    className: "gumus",
    features: [
        { id: 1, text: "Ayrıcalıklı alanda stant imkânı" },
        { id: 2, text: "Firma isim ve logosunun fuar web sitesinde, sosyal medya hesaplarında ve Cumhurbaşkanlığı Yetenek Kapısı'nda Gümüş Sponsor olarak duyurulması" },
        { id: 3, text: "Açılış protokolü sunum alanı arkasında logo kullanım hakkı" },
        { id: 4, text: "Firma yetkililerine açılışta ön sırada yer verilmesi ve açılışta plaket takdimi" },
        { id: 5, text: "Yüz yüze görüşme alanı kullanma imkânı" },
        { id: 6, text: "Etkinlikler için atölye alanı tahsis edilmesi" }
    ]
}

export const bronz_sponsorluk =
{
    title: "Bronz Sponsorluk",
    className: "bronz",
    features: [
        { id: 1, text: "Ayrıcalıklı alanda stant imkânı" },
        { id: 2, text: "Firma isim ve logosunun fuar web sitesinde, sosyal medya hesaplarında ve Cumhurbaşkanlığı Yetenek Kapısı'nda Bronz Sponsor olarak duyurulması" },
        { id: 3, text: "Açılış protokolü sunum alanı arkasında logo kullanım hakkı" },
        { id: 4, text: "Firma yetkililerine açılışta ön sırada yer verilmesi ve açılışta plaket takdimi" },
        { id: 5, text: "Yüz yüze görüşme alanı kullanma imkânı" }
    ]
}

export const standart_katilim =
{
    title: "Standart Katılım",
    className: "standart",
    features: [
        { id: 1, text: "Stant alanı" },
        { id: 2, text: "Firma ismini web sitesinde ve yetenek kapısında duyurma" },
        { id: 3, text: "Yüz yüze görüşme alanı kullanma imkânı" }
    ]
}